// "Text size" setting: one CSS variable, --font-scale, multiplies every font-size and
// line-height (see plugins/font-scale/postcss-font-scale.js). Slider from 50 % to 150 % in 5 %
// steps, stored per browser; applied on import, before the first render, so the page never flashes.
const STORAGE_KEY = "mw_font_scale";
export const FONT_SCALE_MIN = 0.5;
export const FONT_SCALE_MAX = 1.5;
export const FONT_SCALE_STEP = 0.05;
export const FONT_SCALE_DEFAULT = 1;

/** Any input → a value on the 5 % grid between 50 % and 150 %, or null if not a number. */
export function normalizeFontScale(value) {
  // Only numbers and non-blank strings: Number(" "), Number(false), Number([]) would all give 0.
  if (typeof value === "string" ? value.trim() === "" : typeof value !== "number") return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  const clamped = Math.min(FONT_SCALE_MAX, Math.max(FONT_SCALE_MIN, n));
  return Math.round(clamped / FONT_SCALE_STEP) * 5 / 100;
}

export function getFontScale() {
  try {
    return normalizeFontScale(localStorage.getItem(STORAGE_KEY)) ?? FONT_SCALE_DEFAULT;
  } catch {
    return FONT_SCALE_DEFAULT;
  }
}

export function applyFontScale(value = getFontScale()) {
  document.documentElement.style.setProperty("--font-scale", String(value));
}

/** Saves and applies a value; returns the value actually used (normalized). */
export function setFontScale(value) {
  const scale = normalizeFontScale(value) ?? FONT_SCALE_DEFAULT;
  try {
    localStorage.setItem(STORAGE_KEY, String(scale));
  } catch {
    /* private mode: still applied for this page */
  }
  applyFontScale(scale);
  return scale;
}

applyFontScale();
// Other open tabs follow a change made in Settings.
window.addEventListener("storage", (e) => { if (e.key === STORAGE_KEY) applyFontScale(); });
